import { useRef, useState, useEffect } from "react";
import emailjs from '@emailjs/browser';
import styled from "styled-components";
import { NoticeList } from "../helper/NoticeList";
import jsonData from '../helper/events.json';

function Notice() {
  const [events, setEvents] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [currentMonth, setCurrentMonth] = useState('');
  const form = useRef();
  useEffect(() => {
    // Load events data from JSON file
    setEvents(jsonData.months);

    // Get current month
    const date = new Date();
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const currentMonthName = monthNames[date.getMonth()];
    setCurrentMonth(currentMonthName);
    setSelectedMonth(currentMonthName);
  }, []);
  const filteredEvents = events.find((event) => event.month === selectedMonth);


  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_75cla6n', 'template_3q9b9nc', form.current, '1xH2kS3PW-vYikG55')
      .then((result) => {
        console.log(result.text);
        alert("Email sent successfully");
      }, (error) => {
        console.log(error.text);
      });
  };
  return (
    <Wrapper>
      <div className="box_container">

        <div>
          <h3>Events for {currentMonth} {new Date().getFullYear()}</h3>


          <div className="events">
            {filteredEvents && (
              <>
                {filteredEvents.events.map((event, index) => (
                  <div key={index} className="card">
                    <div className="icon">
                      <div className="day">{event.date.split('-')[0]}</div>
                      <div className="month">{event.date.split('-')[1]}</div>
                    </div>
                    <div className="activity">{event.event}</div>
                  </div>
                ))}
              </>
            )}
          </div>

        </div>
        <div className="notice__board">
          <h3>Latest Updates</h3>

          {NoticeList.map((notice) => (
            <div className="notice" key={notice.id}>
              {notice.notice === '#' ? (
                <span>{notice.title}</span>
              ) : (
                <a href={`${notice.notice}`} target="_blank" rel="noopener noreferrer"> {notice.title}</a>
              )}
            </div>
          ))}
        </div>
      </div>
    </Wrapper>
  );
}
const Wrapper = styled.section`
  margin-top: 50px;

  .box_container {
    display: flex;
    margin: 0 100px;
    /* This ensures children stay centered if they are smaller than the container */
    align-items: flex-start; 
  }
    .box_container > div{
flex: 1;
padding: 0 20px;
display: flex;
flex-direction: column;
}
h3{
text-align:center;
font-size:3rem;
margin-bottom:3rem;
height: 6rem; /* fixed height for headings */
}
.events {
display: flex;
flex-direction: column;
gap: 2rem;
flex-grow: 1; /* take up remaining space */
}
.card {
display: flex;
gap: 2rem;
border-bottom:.1rem solid red;
}
.icon {
min-width: 10rem;
height: 7rem;
background-color: black;
border-top-left-radius: 2rem;
border-bottom-right-radius: 2rem;
}
.day {
color: white;
font-size: 2rem;
text-align: center;
background-color: red;
border-top-left-radius: 2rem;
}
.month {
color: white;
font-size: 1.5rem;
text-align: center;
}
.activity {
font-size: 2rem;
color: red;
}
.notice {
color: red;
font-size: 2rem;
border-bottom:0.2rem solid red;
padding-bottom:2rem;
margin-right: 3rem;
&:hover{
font-weight: 500;
}
}

  /* ... your existing styles ... */

  .contact-form {
    width: 100%; // Ensure it tries to take full width
    max-width: 50rem;
    margin: 0 auto; // Centers the form block itself

    .contact-form-inputs {
      display: flex;
      flex-direction: column;
      gap: 1.2rem;
      width: 100%; // Force inputs to fill the form width

      input, textarea {
        width: 100%; // Ensures all fields touch the edges
        box-sizing: border-box; // Prevents padding from breaking width
      }
    }
  }

  /* Mobile Overrides */
 @media (max-width: 768px) {
 margin-bottom:50px;
  .box_container {
    flex-direction: column;
    align-items:center;
    margin: 0 10px; // Changed to auto to center the container
    // Added a max-width to center the content
    gap:50px;
  }

  .box_container > div {
    width: 100%; // Makes each section (Enquiry, Events, Updates) full width
    padding: 0;
  }

  .contact-form {
  display:none;
    max-width: 100%; // Removes the 50rem limit on small screens
    
    .contact-form-inputs {
      width: 100%; // Ensures inputs fill the screen width minus margins
    }
  }
}
  }
`;
export default Notice;
